{
  "id": "campaign-073",
  "name": "Clover Range",
  "seed": "campaign:73",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "...,......_#",
    "..,,,oo..._.",
    "...,ooFo.._.",
    "....TooTs._.",
    "..W.....sW_.",
    "....h..hss_.",
    "..W......W_.",
    ",........._.",
    ".,........_.",
    ",.,......._.",
    ".,,,......_.",
    "..,.h..h.._.",
    ".x........_.",
    "..h......h_.",
    "..,...,..._.",
    ".,,.#,,,.._.",
    "..,...,.....",
    "S..........."
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 11,
      "y": 3
    },
    {
      "kind": "rabbit",
      "x": 5,
      "y": 7
    },
    {
      "kind": "rabbit",
      "x": 2,
      "y": 2
    },
    {
      "kind": "squirrel",
      "x": 11,
      "y": 8
    },
    {
      "kind": "squirrel",
      "x": 4,
      "y": 14
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 6,
      "y": 10
    },
    {
      "kind": "gas",
      "x": 2,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 13
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 3
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 3,
      "y": 16
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 9
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 13
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 9
    },
    {
      "kind": "repair",
      "x": 8,
      "y": 16
    }
  ],
  "moles": {
    "hills": 3,
    "first": 30,
    "every": 20
  },
  "generatorVersion": 3,
  "level": 73,
  "biome": "golf",
  "par": {
    "reel": 8872,
    "push": 6784,
    "selfPropelled": 6228,
    "tractor": 5010,
    "zeroTurn": 4360,
    "fairway": 2786
  },
  "routeTries": {
    "par": {
      "reel": 0,
      "push": 12,
      "selfPropelled": 2,
      "tractor": 0,
      "zeroTurn": 1,
      "fairway": 3
    }
  }
}
